import { ReactNode } from 'react';
import { ScrollableBodyStyled } from './styled';

type ScrollableBodyProps = {
  children: ReactNode;
  gutterBottom?: boolean;
  className?: string;
};

export const ScrollableBody = ({ children, gutterBottom, className }: ScrollableBodyProps) => {
  return (
    <ScrollableBodyStyled gutterBottom={gutterBottom} className={className}>
      {children}
    </ScrollableBodyStyled>
  );
};
